import './App.scss';
import { Routes, Route, Navigate } from 'react-router-dom';
import Main from './screens/main/Main';
import AdminMain from './Admin/AdminRouter';
import ServiceInfo, { ServiceInfoRedirect } from './screens/serviceinfo/ServiceInfo';
import Sample from './screens/samples/Sample';
import Inquiry from './screens/serviceapply/inquiry/Inquiry';
import MvpConfirm from './screens/serviceapply/mvp-confirm/MvpConfirm';
import Contract from './screens/serviceapply/contract/Contract';
import Payment from './screens/serviceapply/payment/Payment';
import PaymentSuccess from './screens/serviceapply/payment/PaymentSuccess';
import PaymentFail from './screens/serviceapply/payment/PaymentFail';
import InquiryComplete from './screens/serviceapply/inquiry-complete/InquiryComplete';
import DeveloperAccountGuide from './screens/serviceapply/developer-account-guide/DeveloperAccountGuide';
import Price from './screens/price/Price';
import Manage from './manage-church/Manage';
import ManageRoll from './manage-roll/ManageRoll';
import ManageFinanceConsole from './manage-finance/ManageFinanceConsole';
import SundaySchoolRouter from './manage-sundayschool/SundaySchoolRouter';
import Company from './screens/company/Company';
import CompanyNotice from './screens/company/CompanyNotice';
import CompanyFAQ from './screens/company/CompanyFAQ';
import Login from './screens/login/Login';
import SiteVisitTracker from './components/SiteVisitTracker';



function App() {

  return (
      <div className="App">
          <SiteVisitTracker/>

          <div className='Main'>

            <Routes>
              <Route path="/" element={<Main/>}/>
              <Route path="/service" element={<ServiceInfoRedirect/>}/>
              <Route path="/service/member" element={<ServiceInfo part="member"/>}/>
              <Route path="/service/admin" element={<ServiceInfo part="admin"/>}/>
              <Route path="/service/roll" element={<ServiceInfo part="roll"/>}/>
              <Route path="/service/finance" element={<ServiceInfo part="finance"/>}/>
              <Route path="/service/sundayschool" element={<ServiceInfo part="sundayschool"/>}/>
              {/* 2026-09-25 이전 '교회 운영' 탭 링크 호환 */}
              <Route path="/service/church" element={<Navigate to="/service/admin" replace/>}/>
              <Route path="/sample" element={<Sample/>}/>
              <Route path="/price" element={<Price/>}/>
              <Route path="/inquiry" element={<Inquiry/>}/>
              <Route path="/inquiry-complete" element={<InquiryComplete/>}/>
              <Route path="/mvp-confirm" element={<MvpConfirm/>}/>
              <Route path="/contract" element={<Contract/>}/>
              <Route path="/payment" element={<Payment/>}/>
              <Route path="/payment/success" element={<PaymentSuccess/>}/>
              <Route path="/payment/fail" element={<PaymentFail/>}/>
              <Route path="/developer-account-guide" element={<DeveloperAccountGuide/>}/>
              <Route path="/login" element={<Login/>}/>
              <Route path="/company" element={<Company/>}/>
              <Route path="/company/notice" element={<CompanyNotice/>}/>
              <Route path="/company/qna" element={<Navigate to="/company/faq" replace/>}/>
              <Route path="/company/faq" element={<CompanyFAQ/>}/>

              <Route path="/manage-app" element={<Manage/>}/>
              <Route path="/manage-roll" element={<ManageRoll/>}/>
              <Route path="/manage-finance" element={<ManageFinanceConsole/>}/>
              <Route path="/manage-ss/*" element={<SundaySchoolRouter/>}/>


              <Route path="/admin/*" element={<AdminMain/>}/>
              
              
              {/* <Route path="/holyssum/*" element={<HolyssumRouter/>}/> */}
              {/* <Route path="/store/*" element={<CommunityMain/>}/> */}
              
              
              
              
              {/* <Route path="/custom/*" element={<BannerCustom/>}/> */}

              
              
            </Routes>
          </div>

      </div>
  );
}

export default App;
